import { createGlobalStyle } from "styled-components";
import "@fontsource/montserrat";

const GlobalStyle = createGlobalStyle`
body, html, #root {width: 100%;height: 100%;margin:0;padding:0;overflow: hidden;}
#root{display: flex;flex:1;align-items: center;justify-content: center; overflow: hidden; background: #EDEFF1; font-family: Montserrat; font-weight: 500;}
.zero {width: 1px;height: 1px;position: absolute;left: 0;bottom: 0;opacity: 0.01;z-index: 99;}

.absolute{position: absolute;}
.relative{position: relative;}
.pointer{cursor: pointer}
.fl {float: left !important;}
.fr {float: right !important;}
.hidden {overflow: hidden !important;}
.none {display: none !important;}
.tl{text-align:  left !important;}
.tr {text-align: right !important;}
.tc {text-align: center !important;}
.bold{font-weight: bold !important;}
.normal{font-weight: normal !important;}
.auto {margin-left: auto; margin-right: auto;display: block;}
.montserrat { font-family: Montserrat; }

  /** flex **/
.fac {display: flex;align-items: center;}
.jsc {display: flex;align-items: center;justify-content: center;}
.jssb {display: flex;align-items: center;justify-content: space-between;}
.jssa {display: flex;align-items: center;justify-content: space-around;}
.f{display: flex;}
.ac{align-items: center;}
.jc{justify-content: center;}
.f1 {flex: 1;}
.f0 {flex: 0;}
.fc{flex-direction: column;}
.fe {display: flex;justify-content: flex-end;}
  
  .fwn{font-weight: normal;}
  .fw1{font-weight: 100;}
  .fw2{font-weight: 200;}
  .fw3{font-weight: 300;}
  .fw4{font-weight: 400;}
  .fw5{font-weight: 500;}
  .fw6{font-weight: 600;}
  .fw7{font-weight: 700;}

  .c0{color:#000;}
  .c9{color:#999;}
  .c8{color:#888;}
  .c7{color:#777;}
  .c6{color:#666;}
  .c5{color:#555;}
  .c4{color:#444;}
  .c3{color:#333;}
  .c2{color:#222;}
  .c1{color:#111;}
  .ca{color:#aaa;}
  .cb{color:#bbb;}
  .cc{color:#ccc;}
  .cd{color:#ddd;}
  .ce{color:#eee;}
  .cf{color:#fff;}

  .pt1{padding-top:1px;}	 .pr1{padding-right:1px;}	 .pb1{padding-bottom:1px;}	 .pl1{padding-left:1px;}
  .pt2{padding-top:2px;}	 .pr2{padding-right:2px;}	 .pb2{padding-bottom:2px;}	 .pl2{padding-left:2px;}
  .pt3{padding-top:3px;}	 .pr3{padding-right:3px;}	 .pb3{padding-bottom:3px;}	 .pl3{padding-left:3px;}
  .pt4{padding-top:4px;}	 .pr4{padding-right:4px;}	 .pb4{padding-bottom:4px;}	 .pl4{padding-left:4px;}
  .pt5{padding-top:5px;}	 .pr5{padding-right:5px;}	 .pb5{padding-bottom:5px;}	 .pl5{padding-left:5px;}
  .pt6{padding-top:6px;}	 .pr6{padding-right:6px;}	 .pb6{padding-bottom:6px;}	 .pl6{padding-left:6px;}
  .pt7{padding-top:7px;}	 .pr7{padding-right:7px;}	 .pb7{padding-bottom:7px;}	 .pl7{padding-left:7px;}
  .pt8{padding-top:8px;}	 .pr8{padding-right:8px;}	 .pb8{padding-bottom:8px;}	 .pl8{padding-left:8px;}
  .pt9{padding-top:9px;}	 .pr9{padding-right:9px;}	 .pb9{padding-bottom:9px;}	 .pl9{padding-left:9px;}
  .pt10{padding-top:10px;}	 .pr10{padding-right:10px;}	 .pb10{padding-bottom:10px;}	 .pl10{padding-left:10px;}
  .pt11{padding-top:11px;}	 .pr11{padding-right:11px;}	 .pb11{padding-bottom:11px;}	 .pl11{padding-left:11px;}
  .pt12{padding-top:12px;}	 .pr12{padding-right:12px;}	 .pb12{padding-bottom:12px;}	 .pl12{padding-left:12px;}
  .pt13{padding-top:13px;}	 .pr13{padding-right:13px;}	 .pb13{padding-bottom:13px;}	 .pl13{padding-left:13px;}
  .pt14{padding-top:14px;}	 .pr14{padding-right:14px;}	 .pb14{padding-bottom:14px;}	 .pl14{padding-left:14px;}
  .pt15{padding-top:15px;}	 .pr15{padding-right:15px;}	 .pb15{padding-bottom:15px;}	 .pl15{padding-left:15px;}
  .pt16{padding-top:16px;}	 .pr16{padding-right:16px;}	 .pb16{padding-bottom:16px;}	 .pl16{padding-left:16px;}
  .pt17{padding-top:17px;}	 .pr17{padding-right:17px;}	 .pb17{padding-bottom:17px;}	 .pl17{padding-left:17px;}
  .pt18{padding-top:18px;}	 .pr18{padding-right:18px;}	 .pb18{padding-bottom:18px;}	 .pl18{padding-left:18px;}
  .pt19{padding-top:19px;}	 .pr19{padding-right:19px;}	 .pb19{padding-bottom:19px;}	 .pl19{padding-left:19px;}
  .pt20{padding-top:20px;}	 .pr20{padding-right:20px;}	 .pb20{padding-bottom:20px;}	 .pl20{padding-left:20px;}
  .pt21{padding-top:21px;}	 .pr21{padding-right:21px;}	 .pb21{padding-bottom:21px;}	 .pl21{padding-left:21px;}
  .pt22{padding-top:22px;}	 .pr22{padding-right:22px;}	 .pb22{padding-bottom:22px;}	 .pl22{padding-left:22px;}
  .pt23{padding-top:23px;}	 .pr23{padding-right:23px;}	 .pb23{padding-bottom:23px;}	 .pl23{padding-left:23px;}
  .pt24{padding-top:24px;}	 .pr24{padding-right:24px;}	 .pb24{padding-bottom:24px;}	 .pl24{padding-left:24px;}
  .pt25{padding-top:25px;}	 .pr25{padding-right:25px;}	 .pb25{padding-bottom:25px;}	 .pl25{padding-left:25px;}
  .pt26{padding-top:26px;}	 .pr26{padding-right:26px;}	 .pb26{padding-bottom:26px;}	 .pl26{padding-left:26px;}
  .pt27{padding-top:27px;}	 .pr27{padding-right:27px;}	 .pb27{padding-bottom:27px;}	 .pl27{padding-left:27px;}
  .pt28{padding-top:28px;}	 .pr28{padding-right:28px;}	 .pb28{padding-bottom:28px;}	 .pl28{padding-left:28px;}
  .pt29{padding-top:29px;}	 .pr29{padding-right:29px;}	 .pb29{padding-bottom:29px;}	 .pl29{padding-left:29px;}
  .pt30{padding-top:30px;}	 .pr30{padding-right:30px;}	 .pb30{padding-bottom:30px;}	 .pl30{padding-left:30px;}

  .mt1{margin-top:1px;}	 .mr1{margin-right:1px;}	 .mb1{margin-bottom:1px;}	 .ml1{margin-left:1px;}
  .mt2{margin-top:2px;}	 .mr2{margin-right:2px;}	 .mb2{margin-bottom:2px;}	 .ml2{margin-left:2px;}
  .mt3{margin-top:3px;}	 .mr3{margin-right:3px;}	 .mb3{margin-bottom:3px;}	 .ml3{margin-left:3px;}
  .mt4{margin-top:4px;}	 .mr4{margin-right:4px;}	 .mb4{margin-bottom:4px;}	 .ml4{margin-left:4px;}
  .mt5{margin-top:5px;}	 .mr5{margin-right:5px;}	 .mb5{margin-bottom:5px;}	 .ml5{margin-left:5px;}
  .mt6{margin-top:6px;}	 .mr6{margin-right:6px;}	 .mb6{margin-bottom:6px;}	 .ml6{margin-left:6px;}
  .mt7{margin-top:7px;}	 .mr7{margin-right:7px;}	 .mb7{margin-bottom:7px;}	 .ml7{margin-left:7px;}
  .mt8{margin-top:8px;}	 .mr8{margin-right:8px;}	 .mb8{margin-bottom:8px;}	 .ml8{margin-left:8px;}
  .mt9{margin-top:9px;}	 .mr9{margin-right:9px;}	 .mb9{margin-bottom:9px;}	 .ml9{margin-left:9px;}
  .mt10{margin-top:10px;}	 .mr10{margin-right:10px;}	 .mb10{margin-bottom:10px;}	 .ml10{margin-left:10px;}
  .mt11{margin-top:11px;}	 .mr11{margin-right:11px;}	 .mb11{margin-bottom:11px;}	 .ml11{margin-left:11px;}
  .mt12{margin-top:12px;}	 .mr12{margin-right:12px;}	 .mb12{margin-bottom:12px;}	 .ml12{margin-left:12px;}
  .mt13{margin-top:13px;}	 .mr13{margin-right:13px;}	 .mb13{margin-bottom:13px;}	 .ml13{margin-left:13px;}
  .mt14{margin-top:14px;}	 .mr14{margin-right:14px;}	 .mb14{margin-bottom:14px;}	 .ml14{margin-left:14px;}
  .mt15{margin-top:15px;}	 .mr15{margin-right:15px;}	 .mb15{margin-bottom:15px;}	 .ml15{margin-left:15px;}
  .mt16{margin-top:16px;}	 .mr16{margin-right:16px;}	 .mb16{margin-bottom:16px;}	 .ml16{margin-left:16px;}
  .mt17{margin-top:17px;}	 .mr17{margin-right:17px;}	 .mb17{margin-bottom:17px;}	 .ml17{margin-left:17px;}
  .mt18{margin-top:18px;}	 .mr18{margin-right:18px;}	 .mb18{margin-bottom:18px;}	 .ml18{margin-left:18px;}
  .mt19{margin-top:19px;}	 .mr19{margin-right:19px;}	 .mb19{margin-bottom:19px;}	 .ml19{margin-left:19px;}
  .mt20{margin-top:20px;}	 .mr20{margin-right:20px;}	 .mb20{margin-bottom:20px;}	 .ml20{margin-left:20px;}
  .mt21{margin-top:21px;}	 .mr21{margin-right:21px;}	 .mb21{margin-bottom:21px;}	 .ml21{margin-left:21px;}
  .mt22{margin-top:22px;}	 .mr22{margin-right:22px;}	 .mb22{margin-bottom:22px;}	 .ml22{margin-left:22px;}
  .mt23{margin-top:23px;}	 .mr23{margin-right:23px;}	 .mb23{margin-bottom:23px;}	 .ml23{margin-left:23px;}
  .mt24{margin-top:24px;}	 .mr24{margin-right:24px;}	 .mb24{margin-bottom:24px;}	 .ml24{margin-left:24px;}
  .mt25{margin-top:25px;}	 .mr25{margin-right:25px;}	 .mb25{margin-bottom:25px;}	 .ml25{margin-left:25px;}
  .mt26{margin-top:26px;}	 .mr26{margin-right:26px;}	 .mb26{margin-bottom:26px;}	 .ml26{margin-left:26px;}
  .mt27{margin-top:27px;}	 .mr27{margin-right:27px;}	 .mb27{margin-bottom:27px;}	 .ml27{margin-left:27px;}
  .mt28{margin-top:28px;}	 .mr28{margin-right:28px;}	 .mb28{margin-bottom:28px;}	 .ml28{margin-left:28px;}
  .mt29{margin-top:29px;}	 .mr29{margin-right:29px;}	 .mb29{margin-bottom:29px;}	 .ml29{margin-left:29px;}
  .mt30{margin-top:30px;}	 .mr30{margin-right:30px;}	 .mb30{margin-bottom:30px;}	 .ml30{margin-left:30px;}

  .mt35{margin-top:35px;}	 .mr35{margin-right:35px;}	 .mb35{margin-bottom:35px;}	 .ml35{margin-left:35px;}
  .mt40{margin-top:40px;}	 .mr40{margin-right:40px;}	 .mb40{margin-bottom:40px;}	 .ml40{margin-left:40px;}
  .mt45{margin-top:45px;}	 .mr45{margin-right:45px;}	 .mb45{margin-bottom:45px;}	 .ml45{margin-left:45px;}
  .mt50{margin-top:50px;}	 .mr50{margin-right:50px;}	 .mb50{margin-bottom:50px;}	 .ml50{margin-left:50px;}

  .t1{top:1px;}	 .r1{right:1px;}	 .b1{bottom:1px;}	 .l1{left:1px;}
  .t2{top:2px;}	 .r2{right:2px;}	 .b2{bottom:2px;}	 .l2{left:2px;}
  .t3{top:3px;}	 .r3{right:3px;}	 .b3{bottom:3px;}	 .l3{left:3px;}
  .t4{top:4px;}	 .r4{right:4px;}	 .b4{bottom:4px;}	 .l4{left:4px;}
  .t5{top:5px;}	 .r5{right:5px;}	 .b5{bottom:5px;}	 .l5{left:5px;}
  .t6{top:6px;}	 .r6{right:6px;}	 .b6{bottom:6px;}	 .l6{left:6px;}
  .t7{top:7px;}	 .r7{right:7px;}	 .b7{bottom:7px;}	 .l7{left:7px;}
  .t8{top:8px;}	 .r8{right:8px;}	 .b8{bottom:8px;}	 .l8{left:8px;}
  .t9{top:9px;}	 .r9{right:9px;}	 .b9{bottom:9px;}	 .l9{left:9px;}
  .t10{top:10px;}	 .r10{right:10px;}	 .b10{bottom:10px;}	 .l10{left:10px;}
  .t11{top:11px;}	 .r11{right:11px;}	 .b11{bottom:11px;}	 .l11{left:11px;}
  .t12{top:12px;}	 .r12{right:12px;}	 .b12{bottom:12px;}	 .l12{left:12px;}
  .t13{top:13px;}	 .r13{right:13px;}	 .b13{bottom:13px;}	 .l13{left:13px;}
  .t14{top:14px;}	 .r14{right:14px;}	 .b14{bottom:14px;}	 .l14{left:14px;}
  .t15{top:15px;}	 .r15{right:15px;}	 .b15{bottom:15px;}	 .l15{left:15px;}
  .t16{top:16px;}	 .r16{right:16px;}	 .b16{bottom:16px;}	 .l16{left:16px;}
  .t17{top:17px;}	 .r17{right:17px;}	 .b17{bottom:17px;}	 .l17{left:17px;}
  .t18{top:18px;}	 .r18{right:18px;}	 .b18{bottom:18px;}	 .l18{left:18px;}
  .t19{top:19px;}	 .r19{right:19px;}	 .b19{bottom:19px;}	 .l19{left:19px;}
  .t20{top:20px;}	 .r20{right:20px;}	 .b20{bottom:20px;}	 .l20{left:20px;}
  .t21{top:21px;}	 .r21{right:21px;}	 .b21{bottom:21px;}	 .l21{left:21px;}
  .t22{top:22px;}	 .r22{right:22px;}	 .b22{bottom:22px;}	 .l22{left:22px;}
  .t23{top:23px;}	 .r23{right:23px;}	 .b23{bottom:23px;}	 .l23{left:23px;}
  .t24{top:24px;}	 .r24{right:24px;}	 .b24{bottom:24px;}	 .l24{left:24px;}
  .t25{top:25px;}	 .r25{right:25px;}	 .b25{bottom:25px;}	 .l25{left:25px;}
  .t26{top:26px;}	 .r26{right:26px;}	 .b26{bottom:26px;}	 .l26{left:26px;}
  .t27{top:27px;}	 .r27{right:27px;}	 .b27{bottom:27px;}	 .l27{left:27px;}
  .t28{top:28px;}	 .r28{right:28px;}	 .b28{bottom:28px;}	 .l28{left:28px;}
  .t29{top:29px;}	 .r29{right:29px;}	 .b29{bottom:29px;}	 .l29{left:29px;}
  .t30{top:30px;}	 .r30{right:30px;}	 .b30{bottom:30px;}	 .l30{left:30px;}

  .w1{width:1px;}	 .h1{height:1px;}
  .w2{width:2px;}	 .h2{height:2px;}
  .w3{width:3px;}	 .h3{height:3px;}
  .w4{width:4px;}	 .h4{height:4px;}
  .w5{width:5px;}	 .h5{height:5px;}
  .w6{width:6px;}	 .h6{height:6px;}
  .w7{width:7px;}	 .h7{height:7px;}
  .w8{width:8px;}	 .h8{height:8px;}
  .w9{width:9px;}	 .h9{height:9px;}
  .w10{width:10px;}	 .h10{height:10px;}
  .w11{width:11px;}	 .h11{height:11px;}
  .w12{width:12px;}	 .h12{height:12px;}
  .w13{width:13px;}	 .h13{height:13px;}
  .w14{width:14px;}	 .h14{height:14px;}
  .w15{width:15px;}	 .h15{height:15px;}
  .w16{width:16px;}	 .h16{height:16px;}
  .w17{width:17px;}	 .h17{height:17px;}
  .w18{width:18px;}	 .h18{height:18px;}
  .w19{width:19px;}	 .h19{height:19px;}
  .w20{width:20px;}	 .h20{height:20px;}
  .w21{width:21px;}	 .h21{height:21px;}
  .w22{width:22px;}	 .h22{height:22px;}
  .w23{width:23px;}	 .h23{height:23px;}
  .w24{width:24px;}	 .h24{height:24px;}
  .w25{width:25px;}	 .h25{height:25px;}
  .w26{width:26px;}	 .h26{height:26px;}
  .w27{width:27px;}	 .h27{height:27px;}
  .w28{width:28px;}	 .h28{height:28px;}
  .w29{width:29px;}	 .h29{height:29px;}
  .w30{width:30px;}	 .h30{height:30px;}

  .w35{width:35px;}	 .h35{height:35px;}
  .w40{width:40px;}	 .h40{height:40px;}
  .w45{width:45px;}	 .h45{height:45px;}
  .w50{width:50px;}	 .h50{height:50px;}
  .w55{width:55px;}	 .h55{height:55px;}
  .w60{width:60px;}	 .h60{height:60px;}
  .w65{width:65px;}	 .h65{height:65px;}
  .w70{width:70px;}	 .h70{height:70px;}
  .w75{width:75px;}	 .h75{height:75px;}
  .w80{width:80px;}	 .h80{height:80px;}
  .w85{width:85px;}	 .h85{height:85px;}
  .w90{width:90px;}	 .h90{height:90px;}
  .w95{width:95px;}	 .h95{height:95px;}
  .w100{width:100px;}	 .h100{height:100px;}
  .w110{width:110px;}	 .h110{height:110px;}
  .w120{width:120px;}	 .h120{height:120px;}
  .w130{width:130px;}	 .h130{height:130px;}
  .w140{width:140px;}	 .h140{height:140px;}
  .w150{width:150px;}	 .h150{height:150px;}
  .w160{width:160px;}	 .h160{height:160px;}
  .w170{width:170px;}	 .h170{height:170px;}
  .w180{width:180px;}	 .h180{height:180px;}
  .w190{width:190px;}	 .h190{height:190px;}
  .w200{width:200px;}	 .h200{height:200px;}
  .w210{width:210px;}	 .h210{height:210px;}
  .w220{width:220px;}	 .h220{height:220px;}
  .w230{width:230px;}	 .h230{height:230px;}
  .w240{width:240px;}	 .h240{height:240px;}
  .w250{width:250px;}	 .h250{height:250px;}
  .w260{width:260px;}	 .h260{height:260px;}
  .w270{width:270px;}	 .h270{height:270px;}
  .w280{width:280px;}	 .h280{height:280px;}
  .w290{width:290px;}	 .h290{height:290px;}
  .w300{width:300px;}	 .h300{height:300px;}
  .w310{width:310px;}	 .h310{height:310px;}
  .w320{width:320px;}	 .h320{height:320px;}
  .w330{width:330px;}	 .h330{height:330px;}
  .w340{width:340px;}	 .h340{height:340px;}
  .w350{width:350px;}	 .h350{height:350px;}
  .w360{width:360px;}	 .h360{height:360px;}
  .w370{width:370px;}	 .h370{height:370px;}
  .w380{width:380px;}	 .h380{height:380px;}
  .w390{width:390px;}	 .h390{height:390px;}
  .w400{width:400px;}	 .h400{height:400px;}

  .fs1{font-size:1px;}	 .lh1{line-height:1px;}	 .indent1{text-indent:1px;}	 .wp1{width: 1%;} 	 .radius1{border-radius: 1px;}
  .fs2{font-size:2px;}	 .lh2{line-height:2px;}	 .indent2{text-indent:2px;}	 .wp2{width: 2%;} 	 .radius2{border-radius: 2px;}
  .fs3{font-size:3px;}	 .lh3{line-height:3px;}	 .indent3{text-indent:3px;}	 .wp3{width: 3%;} 	 .radius3{border-radius: 3px;}
  .fs4{font-size:4px;}	 .lh4{line-height:4px;}	 .indent4{text-indent:4px;}	 .wp4{width: 4%;} 	 .radius4{border-radius: 4px;}
  .fs5{font-size:5px;}	 .lh5{line-height:5px;}	 .indent5{text-indent:5px;}	 .wp5{width: 5%;} 	 .radius5{border-radius: 5px;}
  .fs6{font-size:6px;}	 .lh6{line-height:6px;}	 .indent6{text-indent:6px;}	 .wp6{width: 6%;} 	 .radius6{border-radius: 6px;}
  .fs7{font-size:7px;}	 .lh7{line-height:7px;}	 .indent7{text-indent:7px;}	 .wp7{width: 7%;} 	 .radius7{border-radius: 7px;}
  .fs8{font-size:8px;}	 .lh8{line-height:8px;}	 .indent8{text-indent:8px;}	 .wp8{width: 8%;} 	 .radius8{border-radius: 8px;}
  .fs9{font-size:9px;}	 .lh9{line-height:9px;}	 .indent9{text-indent:9px;}	 .wp9{width: 9%;} 	 .radius9{border-radius: 9px;}
  .fs10{font-size:10px;}	 .lh10{line-height:10px;}	 .indent10{text-indent:10px;}	 .wp10{width: 10%;} 	 .radius10{border-radius: 10px;}
  .fs11{font-size:11px;}	 .lh11{line-height:11px;}	 .indent11{text-indent:11px;}	 .wp11{width: 11%;} 	 .radius11{border-radius: 11px;}
  .fs12{font-size:12px;}	 .lh12{line-height:12px;}	 .indent12{text-indent:12px;}	 .wp12{width: 12%;} 	 .radius12{border-radius: 12px;}
  .fs13{font-size:13px;}	 .lh13{line-height:13px;}	 .indent13{text-indent:13px;}	 .wp13{width: 13%;} 	 .radius13{border-radius: 13px;}
  .fs14{font-size:14px;}	 .lh14{line-height:14px;}	 .indent14{text-indent:14px;}	 .wp14{width: 14%;} 	 .radius14{border-radius: 14px;}
  .fs15{font-size:15px;}	 .lh15{line-height:15px;}	 .indent15{text-indent:15px;}	 .wp15{width: 15%;} 	 .radius15{border-radius: 15px;}
  .fs16{font-size:16px;}	 .lh16{line-height:16px;}	 .indent16{text-indent:16px;}	 .wp16{width: 16%;} 	 .radius16{border-radius: 16px;}
  .fs17{font-size:17px;}	 .lh17{line-height:17px;}	 .indent17{text-indent:17px;}	 .wp17{width: 17%;} 	 .radius17{border-radius: 17px;}
  .fs18{font-size:18px;}	 .lh18{line-height:18px;}	 .indent18{text-indent:18px;}	 .wp18{width: 18%;} 	 .radius18{border-radius: 18px;}
  .fs19{font-size:19px;}	 .lh19{line-height:19px;}	 .indent19{text-indent:19px;}	 .wp19{width: 19%;} 	 .radius19{border-radius: 19px;}
  .fs20{font-size:20px;}	 .lh20{line-height:20px;}	 .indent20{text-indent:20px;}	 .wp20{width: 20%;} 	 .radius20{border-radius: 20px;}
  .fs21{font-size:21px;}	 .lh21{line-height:21px;}	 .indent21{text-indent:21px;}	 .wp21{width: 21%;} 	 .radius21{border-radius: 21px;}
  .fs22{font-size:22px;}	 .lh22{line-height:22px;}	 .indent22{text-indent:22px;}	 .wp22{width: 22%;} 	 .radius22{border-radius: 22px;}
  .fs23{font-size:23px;}	 .lh23{line-height:23px;}	 .indent23{text-indent:23px;}	 .wp23{width: 23%;} 	 .radius23{border-radius: 23px;}
  .fs24{font-size:24px;}	 .lh24{line-height:24px;}	 .indent24{text-indent:24px;}	 .wp24{width: 24%;} 	 .radius24{border-radius: 24px;}
  .fs25{font-size:25px;}	 .lh25{line-height:25px;}	 .indent25{text-indent:25px;}	 .wp25{width: 25%;} 	 .radius25{border-radius: 25px;}
  .fs26{font-size:26px;}	 .lh26{line-height:26px;}	 .indent26{text-indent:26px;}	 .wp26{width: 26%;} 	 .radius26{border-radius: 26px;}
  .fs27{font-size:27px;}	 .lh27{line-height:27px;}	 .indent27{text-indent:27px;}	 .wp27{width: 27%;} 	 .radius27{border-radius: 27px;}
  .fs28{font-size:28px;}	 .lh28{line-height:28px;}	 .indent28{text-indent:28px;}	 .wp28{width: 28%;} 	 .radius28{border-radius: 28px;}
  .fs29{font-size:29px;}	 .lh29{line-height:29px;}	 .indent29{text-indent:29px;}	 .wp29{width: 29%;} 	 .radius29{border-radius: 29px;}
  .fs30{font-size:30px;}	 .lh30{line-height:30px;}	 .indent30{text-indent:30px;}	 .wp30{width: 30%;} 	 .radius30{border-radius: 30px;}

  .wp5{width: 5%;} 
  .wp10{width: 10%;} 
  .wp15{width: 15%;} 
  .wp20{width: 20%;} 
  .wp25{width: 25%;} 
  .wp30{width: 30%;} 
  .wp35{width: 35%;} 
  .wp40{width: 40%;} 
  .wp45{width: 45%;} 
  .wp50{width: 50%;} 
  .wp55{width: 55%;} 
  .wp60{width: 60%;} 
  .wp65{width: 65%;} 
  .wp70{width: 70%;} 
  .wp75{width: 75%;} 
  .wp80{width: 80%;} 
  .wp85{width: 85%;} 
  .wp90{width: 90%;} 
  .wp95{width: 95%;} 
  .wp100{width: 100%;} 
`;

export default GlobalStyle;
